export class AuditTimelineEvent {
    id: string;
    sourceType: string;
    eventCategory: string;
    actionType: string;
    entityType: string;
    timestamp: Date;
    title: string;
    description: string;
    author: string;
    workflowName: string;
    submitted: boolean;
    icon: string;
    comments: any[];
}

export class AuditTimelineResponse {
    events: AuditTimelineEvent[];
    total: number;
    offset: number;
    limit: number;
}

export class AuditTimelineGroup {
    dateLabel: string;
    entries: AuditTimelineEvent[];
}



// WEBPACK FOOTER //
// ./src/app/entities/audit/audit.model.ts